export const file = {
  failedToGetImage: '获取图片失败',
  takeVideo: '拍视频',
  takePhoto: '拍照',
  selectImageFromAlbum: '从相册选择图片',
  selectFile: '选择文件',
  uploadImage: '上传图片',
  uploadPDF: '上传PDF',
  uploadVideo: '上传视频',
  uploadAudio: '上传音频',
  maxFileVerify: '每次最多上传{max}个文件',
  supportFormatVerify: '上传错误，仅支持{suffix}格式的文件',
  downloaded: '已下载 {progress} %',
  fileDownload: '文件下载',
  videoPlaybackError: '视频播放错误，请刷新界面重试',
  viewPDF: '查看PDF',
  attachment: '附件',
  download: '下载',
  choosePhoto: '选择照片',
  chooseVideo: '选择视频',
  publishPhoto: '发布图片',
  publishVideo: '发布视频',
  publishPDF: '发布PDF',
  publishAudio: '发布音频',
  uploadPhoto: '上传照片'
};
